import API from "@/services/api";
import { 
  MoveVBAPIResponse,
  MoveVBAPIParams
} from "../types/virtualBattery";

export enum EndpointName {
  MoveVirtualBatteries = '/contract/:contractName/bateria_virtual_move_virtual_battery/:bateriaOrigenId'
}

const moveVirtualBatteries = (
    contractName: string,
    bateriaOrigenId: number, 
    bateriaDestiId: number, 
    percentatge: number
) => {
  return API.put<MoveVBAPIResponse, MoveVBAPIParams>({
    endpoint: EndpointName.MoveVirtualBatteries,
    versions: [2],
    data: { 
      pes_percentatge: percentatge,
      bateria_desti: bateriaDestiId
    },
    params: {
      contractName,
      bateriaOrigenId
    }
  });
}

export default {
  moveVirtualBatteries
};